import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { IAccountResponse } from "../../types/auth";

interface IState {
    token: string | null;
    refreshToken: string | null;
    account: IAccountResponse | null;
}

const initialState: IState = { token: null, refreshToken: null, account: null };

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setAuthTokens(state: IState, action: PayloadAction<{ token: string; refreshToken: string }>) {
            state.refreshToken = action.payload.refreshToken;
            state.token = action.payload.token;
        },
        setAccount(state: IState, action: PayloadAction<IAccountResponse>) {
            state.account = action.payload;
        },
        logout(state: IState) {
            state.account = null;
            state.refreshToken = null;
            state.token = null;
        },
    },
});

export const { setAuthTokens, setAccount, logout } = authSlice.actions;

export default authSlice.reducer;
